import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO55 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK005-5.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO55
